import React, { Component } from 'react';

class Video extends Component {
    getEmbedCode(video) {
        if (video.indexOf("vimeo") > -1) {
            const vidId = video.split("/")[3];
            return "https://player.vimeo.com/video/" + vidId + "?color=290088&byline=0&portrait=0&title=0";
        } else {
            const vidId = video.split("=")[1];
            return "https://www.youtube.com/embed/" + vidId;
        }
    }

    render() {
        return (
            this.props.url.length > 0 &&
            <div className="video-wrapper">
              <iframe src={this.getEmbedCode(this.props.url)} width="640" height="360" frameBorder="0" allowFullScreen></iframe>
            </div>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/other/Video.js